// extracted by mini-css-extract-plugin
export default {"title":"SkillsTable_title__qclYm","date":"SkillsTable_date__3CyPb"};